import React from 'react'
import FindCommunitiesContainer from '../../Containers/FindCommunities'
function index() {
  return (
    <FindCommunitiesContainer />
  )
}

export default index